import type { IAccessSyncRepository, PaginatedResponse, PartialSyncType } from '@yawi/domain';
import type {
  SyncStatusResponse,
  FailedSyncEntry,
  StartSyncResponse,
  RetryFailedResponse,
  SyncEntityType,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

const BASE_URL = 'v1/tenant/integrations/sync';

export class ApiAccessSyncRepository implements IAccessSyncRepository {
  async getStatus(): Promise<SyncStatusResponse> {
    const client = getApiClient();
    return client.get<SyncStatusResponse>(`${BASE_URL}/status`);
  }

  async startFullSync(): Promise<StartSyncResponse> {
    const client = getApiClient();
    return client.post<StartSyncResponse>(`${BASE_URL}/start`);
  }

  async startPartialSync(types: PartialSyncType[]): Promise<StartSyncResponse> {
    const client = getApiClient();
    return client.post<StartSyncResponse>(`${BASE_URL}/start-partial`, { types });
  }

  async retryFailed(entityType?: SyncEntityType): Promise<RetryFailedResponse> {
    const client = getApiClient();
    return client.post<RetryFailedResponse>(`${BASE_URL}/retry`, entityType ? { entityType } : {});
  }

  async cancelSync(): Promise<void> {
    const client = getApiClient();
    await client.post<void>(`${BASE_URL}/cancel`);
  }

  async getFailedEntries(page: number, limit: number): Promise<PaginatedResponse<FailedSyncEntry>> {
    const client = getApiClient();
    return client.get<PaginatedResponse<FailedSyncEntry>>(
      `${BASE_URL}/failed?page=${page}&limit=${limit}`,
    );
  }

  async retrySingle(syncMapId: string): Promise<void> {
    const client = getApiClient();
    await client.post<void>(`${BASE_URL}/retry/${syncMapId}`);
  }
}
